import React from 'react'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import SiteSeo from '../../components/components/seo/SiteSeo'
import { useTranslation } from 'next-i18next'
import Main from '../../components/components/PurchaseOrder/Main';
function index(props) {
    const {t}=useTranslation("common")
    return (
        <div>
            <SiteSeo title={t("purchaseorder")}/>
            <Main/>
        </div>
    )
}

export default index
export async function getServerSideProps({ locale, params}) {


    return {
      props: {
        ...(await serverSideTranslations(locale, ["common"])),
     
      }
    }};
